import React, { useState } from 'react';

import { ReactComponent as IconLoading } from '../../assets/icons/spinner.svg';
import { ReactComponent as IconEdit } from '../../assets/icons/edit.svg';
import { ReactComponent as IconDetails } from '../../assets/icons/info.svg';
import { ReactComponent as IconDel } from '../../assets/icons/trash.svg';
import { useNavigate } from 'react-router-dom';
import { showError, ucwords } from '../../utils';
import { deleteReferente } from '../../api';

// Righe di chiamate raggruppate con espansione dettagli
const ReferentiListRow = ({ contact, setRawList }) => {
    const { id, cognome, nome, email, data_creazione} = contact;
    const [expanded, setExpanded] = useState(false);
    const [isLoadingDel, setIsLoadingDel] = useState(false);
    const navigate = useNavigate();
    
    const handleContactClick = () => setExpanded(prev => !prev);

    const handleRemoveReferente = async () => {
        setIsLoadingDel(true);
        try{
            await deleteReferente(id);
            setRawList(prev => prev.filter(item => item.id !== id));
        }catch(err){
            showError([err.message]);
        }finally{
            setIsLoadingDel(false);
        }
    }

    let cognomeLower = ucwords(cognome);
    let nomeLower = ucwords(nome);

   
    return (
        <div className={`vista-row`}>
            <div className="vista-row-info">
                <div className="sx">
                    <div className="item" onClick={handleContactClick} >
                        <span className="title text-trunc-ellipsis">{cognomeLower} {nomeLower}</span>
                        <div className='item-content'>
                            <span className="subtitle text-trunc-ellipsis">
                                {email}
                            </span>
                            <div className="actions">
                                <button className="icon-button"><IconEdit onClick={() => navigate('/referente', { state: { id } })} /></button>
                                <button className="icon-button"><IconDetails onClick={() =>  navigate('/referente', { state: { id, op: 'show' } })} /></button>
                                <button className="icon-button" onClick={handleRemoveReferente} disabled={isLoadingDel}>{isLoadingDel ? <IconLoading className="icon icon-loading"/> : <IconDel/>}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ReferentiListRow;